export default __webpack_public_path__ + "static/media/IMG_0455 copie.41ad8090.jpg";